<template>
  <b-row>
    <b-col cols="12">
      <b-form-input
        id="table-search"
        v-model="searchIpAddress"
        placeholder="Search Blacklists"
        type="text"
      />
      <b-table
        v-b-scrollspy
        outlined
        striped
        hover
        :items="blacklists"
        head-variant="light"
        :fields="tableFields"
        :filter="searchIpAddress"
        show-empty
        empty-text="No blacklists found."
      >
        <template v-slot:cell(expiresAt)="data">
          <span :class="{ 'text-danger': isExpired(data.item) }">
            {{ formatExpiresAt(data.item) }}
          </span>
        </template>
        <template v-slot:cell(actions)="data">
          <button
            class="btn btn-outline-danger border-0"
            type="button"
            @click="deleteBlacklist(data.item.ipAddress)"
          >
            <span class="fa fa-trash" />
          </button>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>
<script>
import { dataAPI } from '../services/DataAPI'

export default {
  data() {
    return {
      blacklists: [],
      tableFields: [
        {
          key: 'ipAddress',
          label: 'IP Address',
          sortable: true
        },
        {
          key: 'authorizationFailures',
          label: 'Failed Attempts',
          sortable: true
        },
        {
          key: 'blockedRequests',
          label: 'Blocked Attempts',
          sortable: true
        },
        {
          key: 'expiresAt',
          label: 'Expiration',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      searchIpAddress: ''
    }
  },
  computed: {
    currentUserToken() {
      return this.$store.state.auth.userToken
    }
  },
  created() {
    this.fetchBlacklists()
  },
  methods: {
    isExpired(blacklist) {
      return blacklist.expiresAt && blacklist.expiresAt.getTime() < Date.now()
    },
    formatInterval(value, label) {
      if (Math.abs(value) > 1) {
        label += 's'
      }
      if (value > 0) {
        return 'in ' + value + ' ' + label
      } else {
        return Math.abs(value) + ' ' + label + ' ago'
      }
    },
    formatExpiresAt(blacklist) {
      const interval = (blacklist.expiresAt.getTime() - Date.now()) / 1000
      const hours = Math.floor(interval / 3600)
      const minutes = Math.floor((interval - (hours * 3600)) / 60)
      const seconds = Math.floor(interval - (hours * 3600) - (minutes * 60))
      if (Math.abs(hours) > 0) {
        return this.formatInterval(hours, 'hour')
      } else if (Math.abs(minutes) > 0) {
        return this.formatInterval(minutes, 'minute')
      } else if (Math.abs(seconds) > 0) {
        return this.formatInterval(seconds, 'second')
      } else {
        return 'any second now'
      }
    },
    fetchBlacklists() {
      dataAPI(this.currentUserToken)
        .getBlacklists()
        .then(blacklists => {
          this.blacklists = blacklists
        })
    },
    deleteBlacklist(ipAddress) {
      dataAPI(this.currentUserToken)
        .deleteBlacklist(ipAddress)
        .then(() => {
          this.fetchBlacklists()
        })
    }
  }
}
</script>
